
import React from "react";

const ColoredLine = (props: any) => {
    const calculateReinforcements = () => {
        let total = 0;
        const list = props.Reinforcements || [];
        for (let index = 0; index < list.length; index++) {
            total += +(list[index]?.student_points ?? list[index]?.points ?? 0);
        }
        return total;
    }

    const total = calculateReinforcements();

    return (
        <>
          <div className="d-flex" style={{ width: "100%" }}>
                <div className="d-flex justify-content-center" style={{ height: "40px", flex: 1 }}>
                    {total <= -3 ? (<img src="assets/images/-3.png" style={{ height: "40px", width: "50px" }} alt="" />) : null}
                </div>
                <div className="d-flex justify-content-center" style={{ height: "40px", flex: 1 }}>
                    {total == -2 ? (<img src="assets/images/-2.png" style={{ height: "40px", width: "50px" }} alt="" />) : null}
                </div>
                <div className="d-flex justify-content-center" style={{ height: "40px", flex: 1 }}>
                    {total == -1 ? (<img src="assets/images/-1.png" style={{ height: "40px", width: "50px" }} alt="" />) : null}
                </div>
                <div className="d-flex justify-content-center" style={{ height: "40px", flex: 1 }}>
                    {total == 0 ? (<img src="assets/images/0.png" style={{ height: "40px", width: "50px" }} alt="" />) : null}
                </div>
                <div className="d-flex justify-content-center" style={{ height: "40px", flex: 1 }}>
                    {total == 1 ? (<img src="assets/images/1.png" style={{ height: "40px", width: "50px" }} alt="" />) : null}
                </div>
                <div className="d-flex justify-content-center" style={{ height: "40px", flex: 1 }}>
                    {total == 2 ? (<img src="assets/images/2.png" style={{ height: "40px", width: "50px" }} alt="" />) : null}
                </div>
                <div className="d-flex justify-content-center" style={{ height: "40px", flex: 1 }}>
                    {total >= 3 ? (<img src="assets/images/3.png" style={{ height: "40px", width: "50px" }} alt="" />) : null}
                </div>

            </div>
            <div className="d-flex" style={{ width: "100%", borderRadius: "4px", overflow: "hidden" }}>
                <div
                    style={{
                        backgroundColor: "red",
                        height: "20px",
                        flex: 1
                    }}
                />
                <div
                    style={{
                        backgroundColor: "orange",
                        height: "20px",
                        flex: 1
                    }}
                />
                <div
                    style={{
                        backgroundColor: "#f9c412",
                        height: "20px",
                        flex: 1
                    }}
                />
                <div
                    style={{
                        backgroundColor: "#f5ee1c",
                        height: "20px",
                        flex: 1
                    }}
                />
                <div
                    style={{
                        backgroundColor: "#b4d232",
                        height: "20px",
                        flex: 1
                    }}
                />
                <div
                    style={{
                        backgroundColor: "#84c341",
                        height: "20px",
                        flex: 1
                    }}
                />
                <div
                    style={{
                        backgroundColor: "#33a949",
                        height: "20px",
                        flex: 1
                    }}
                />
            </div>

          
        </>
    );
}

export default ColoredLine;